module.exports = __webpack_public_path__ + "static/img/xi_2.41be406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_2.jpg
// module id = R5SV
// module chunks = 1